import { gql, useMutation } from '@apollo/client';
import { subscriptionsPublicClient } from 'lib/apollo/clients';

export const CREATE_TRIAL_NO_CARD = gql`
  mutation createAccountWithNoCreditCardTrial(
    $input: CreateAccountWithNoCreditCardTrialInput!
  ) {
    createAccountWithNoCreditCardTrial(input: $input) {
      idToken
      organization {
        businessName
        id
        locations {
          uid
          podiumNumber
        }
        uid
      }
      refreshToken
      userUid
    }
  }
`;

const useCreateTrialNoCard = () =>
  useMutation(CREATE_TRIAL_NO_CARD, { client: subscriptionsPublicClient });

export default useCreateTrialNoCard;
